import { render, staticRenderFns } from "./LeadPage.vue?vue&type=template&id=d85b86bc&scoped=true&lang=html"
import script from "./LeadPage.vue?vue&type=script&lang=js"
export * from "./LeadPage.vue?vue&type=script&lang=js"
import style0 from "./LeadPage.vue?vue&type=style&index=0&id=d85b86bc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85b86bc",
  null
  
)

export default component.exports